<template>
  <div>
    <!-- <pre>{{lastsensor}}</pre>
  <pre v-for="i in lastsensor" :key="i"><li >{{i.data}}</li></pre> -->

    <vs-list-header
      title="Overview Sensor"
      style="font-size: 18px"
      color="dark"
    ></vs-list-header>
    <div v-if="username == 'frasers.kho'">
      <vs-select
        class="selectExample mt-3 mb-1"
        label="Warehouse Select"
        v-model="selectWarehouse"
        @change="changTableFracer"
      >
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in optionsWarehouse"
        />
      </vs-select>

      <vs-table
        hoverFlat="false"
        max-items="5"
        pagination
        stripe
        :data="lastsensor"
      >
        <template slot="thead">
          <vs-th id="noWrap"> Sensor Name </vs-th>
          <vs-th id="noWrap"> Temperature </vs-th>
          <vs-th id="noWrap"> Humidity </vs-th>
          <vs-th id="noWrap"> Active Status </vs-th>
          <vs-th id="noWrap"> Signal </vs-th>
          <vs-th id="noWrap"> Battery </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr id="fontSizeData" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-button
                id="noWrap"
                @click="viewSensor(tr)"
                icon="signal_cellular_alt"
                type="flat"
                >{{ data[indextr].name }}</vs-button
              >
            </vs-td>
            <vs-td>
              <div>{{ data[indextr].temp }} °C</div>
            </vs-td>
            <vs-td>
              <div>{{ data[indextr].humid }} %</div>
            </vs-td>
            <vs-td>
              <vs-icon
                icon="fiber_manual_record"
                v-if="data[indextr].active == 1"
                color="primary"
                class="ml-3"
              ></vs-icon>
              <vs-icon
                icon="fiber_manual_record"
                v-else-if="data[indextr].active == 2"
                color="yellow"
                class="ml-3"
              ></vs-icon>
              <vs-icon
                icon="fiber_manual_record"
                v-else
                color="grey"
                class="ml-3"
              ></vs-icon>
            </vs-td>
            <vs-td>
              <vs-icon icon="rss_feed" color="primary" class="ml-3"></vs-icon>
            </vs-td>
            <vs-td>
              <div
                v-if="data[indextr].bat == 100"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-success mr-2">
                  <vs-icon icon="battery_full"></vs-icon>
                </a>
                <a class="text-success"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else-if="data[indextr].bat != 100 && data[indextr].bat > 25"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-secondary mr-2">
                  <vs-icon icon="battery_full"></vs-icon>
                </a>
                <a class="text-secondary"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else-if="data[indextr].bat <= 25"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-danger mr-2">
                  <vs-icon icon="battery_alert"></vs-icon>
                </a>
                <a class="text-danger"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-success mr-2">
                  <!-- <img src="../../../../assets/electrical_services-black-36dp.svg" style="color: green"/> -->
                  <vs-icon icon="battery_full" class="ml-3"></vs-icon>
                </a>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div v-else>
      <vs-table
        hoverFlat="false"
        max-items="5"
        pagination
        stripe
        :data="lastsensor"
      >
        <template slot="thead">
          <vs-th id="noWrap"> Sensor Name </vs-th>
          <vs-th id="noWrap"> Sensor Type </vs-th>
          <vs-th id="noWrap"> Reading Data </vs-th>
          <vs-th id="noWrap"> Battery </vs-th>
          <vs-th id="noWrap"> Timestamp </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr id="fontSizeData" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-button
                id="noWrap"
                @click="viewSensor(tr)"
                icon="signal_cellular_alt"
                type="flat"
                >{{ data[indextr].name }}</vs-button
              >
            </vs-td>
            <vs-td>
              <span
                v-if="data[indextr].type == 'Temp&Humid'"
                class="font-weight-normal badge badge-info badge-pill px-2 py-1"
                >{{ data[indextr].type }}</span
              >
              <span
                v-if="data[indextr].type == 'Powermeter'"
                class="
                  font-weight-normal
                  badge badge-warning badge-pill
                  px-2
                  py-1
                "
                >{{ data[indextr].type }}</span
              >
              <span
                v-if="data[indextr].type == 'Temperature'"
                class="
                  font-weight-normal
                  badge badge-success badge-pill
                  px-2
                  py-1
                "
                >{{ data[indextr].type }}</span
              >
              <span
                v-if="data[indextr].type == 'Door Sensor'"
                class="
                  font-weight-normal
                  badge badge-secondary badge-pill
                  px-2
                  py-1
                "
                >{{ data[indextr].type }}</span
              >
              <span
                v-else
                class="
                  font-weight-normal
                  badge badge-secondary badge-pill
                  px-2
                  py-1
                "
                >{{ data[indextr].type }}</span
              >
            </vs-td>
            <vs-td>
              <div v-if="data[indextr].data.match(/temperatureSensor_1/)">
                {{ data[indextr].data }} °C
              </div>
              <div v-else-if="data[indextr].data.match(/humiditySensor_1/)">
                {{ data[indextr].data }} %
              </div>
              <div v-else>{{ data[indextr].data }}</div>
            </vs-td>
            <vs-td>
              <div
                v-if="data[indextr].bat == 100"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-success mr-2">
                  <vs-icon icon="battery_full"></vs-icon>
                </a>
                <a class="text-success"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else-if="data[indextr].bat != 100 && data[indextr].bat > 25"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-secondary mr-2">
                  <vs-icon icon="battery_full"></vs-icon>
                </a>
                <a class="text-secondary"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else-if="data[indextr].bat <= 25"
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-danger mr-2">
                  <vs-icon icon="battery_alert"></vs-icon>
                </a>
                <a class="text-danger"> {{ data[indextr].bat }}% </a>
              </div>
              <div
                v-else
                class="d-flex"
                style="display: flex; align-items: center"
              >
                <a class="text-success mr-2">
                  <!-- <img src="../../../../assets/electrical_services-black-36dp.svg" style="color: green"/> -->
                  <vs-icon icon="battery_full" class="ml-3"></vs-icon>
                </a>
              </div>
            </vs-td>
            <vs-td>
              {{ data[indextr].date }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "LastSensorState",
  data: () => ({
    temp: [],
    nwlist: [],
    sensorlist: [],
    lastsensor: [],
    tempsensor: [],
    interval: "",
    username: "",
    selectWarehouse: "Rojana Warehouse",
    optionsWarehouse: [
      { text: "Kendall", value: "KhonKaen Warehouse" },
      { text: "Endeavor", value: "Rojana Warehouse" },
      { text: "Unicorn", value: "Bangplee Warehouse" },
    ],
  }),
  methods: {
    viewSensor(item) {
      console.log(item);
      //  console.log(this.sensorId[item])
      // this.$API
      //   .get("sensors/user")
      //   .then((result) => {
      //     let sensor = result.data.filter(
      //       (sensor) => sensor.id == this.sensorId[item]
      //     );
      //     if (sensor) {
      //       let item = sensor[0];
      //       this.$session.set("nwname", item.network);
      //       this.$session.set("statussensor", item.active);
      //       this.$session.set("nwid", item.nwid);
      //       this.$session.set("sensorname", item.name);
      //       this.$session.set("sensorid", item.serial_id);
      //       this.$session.set("gatewayid", item.gatewayid);
      //       this.$session.set("type", item.type);
      //       this.$session.set("lora", item.lora);
      //       this.$session.set("id", item.id);
      //       this.$router.push({
      //         name: "SensorDashboard",
      //         params: {
      //           // nwname: sensor.network,
      //           nwid: item.nwid,
      //           sensorid: item.serial_id,
      //           gatewayid: item.gatewayid,
      //           type: item.type,
      //           id: item.id,
      //         },
      //       });
      //     }
      //   });
    },
    changTableFracer() {
      // console.log(this.selectWarehouse);
      this.lastsensor = this.tempsensor;
      this.lastsensor = this.lastsensor.filter(
        (item) => item.network == this.selectWarehouse
      );
      // switch (this.selectWarehouse) {
      //   case 1:
      //     this.lastsensor = this.b ;
      //     break;
      //   case 2:
      //     console.log("Rojana");
      //     break;
      //   default:
      //     console.log("Try looking up for a hint.");
      // }
    },
    checkNetwork(item) {
      return (item.network = this.selectWarehouse);
    },
    async getSensorData() {
      var lastdata = null;
      var tempel = {};
      var temp = [];
      await this.$API.get("sensors/user").then((result) => {
        temp = [];
        console.log(result.data);
        result.data.forEach((element) => {
          // console.log(element.lastdata)
          if (element.type == "monnit")
            // console.log(element.lastdata)
            element.data = "";
          try {
            lastdata = JSON.parse(element.lastdata);
          } catch (err) {
            lastdata = [];
            element.lastdata.forEach((el, i) => {
              lastdata[i] = JSON.parse(el);
            });
            // console.log(lastdata)
          }
          // console.log(lastdata)
          switch (element.type) {
            case "control":
              Object.keys(lastdata.control).forEach((el, i) => {
                // // console.log(JSON.parse(element.lastdata)[el])
                tempel.name = element.name;
                tempel.type = element.type;
                tempel.data = Object.keys(lastdata.control)[i] + " = ";
                if (JSON.parse(element.lastdata)[el]) tempel.data += "On";
                else tempel.data += "Off";
                tempel.date = this.$moment(
                  this.$moment(lastdata.jtimestamp["time" + i]).subtract(
                    7,
                    "hours"
                  )
                ).format("YYYY-MM-DD HH:mm:ss");
                temp.push(tempel);
                tempel = {};
              });
              break;
                case "ssc":
            case "advantech":
              // console.log(lastdata)
              Object.keys(lastdata).forEach((el, i) => {
                // // console.log(el)
                switch (el) {
                  case "ph":
                  case "ph1":
                  case "ph2":
                    // // console.log('case AI')
                    tempel.name = element.name;
                    tempel.type = element.type;
                    tempel.data = "PH: " + parseFloat(lastdata[el]).toFixed(2);
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "temp":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    tempel.data = "Temp: " + lastdata[el];
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "totalflow":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    tempel.data =
                      "Total Flow: " + parseFloat(lastdata[el]).toFixed(2);
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "kwhtotal":
                  case "kwhtotal1":
                  case "kwhtotal2":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    tempel.data =
                      "Power Consumption: " +
                      parseFloat(lastdata[el]).toFixed(2);
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  // case 'reverseflow':
                  //   tempel.name = element.name
                  //   tempel.type = element.type
                  //   tempel.data = "Reverse Total Flow: "+parseFloat(lastdata[el]).toFixed(2)
                  //   tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                  //   temp.push(tempel)
                  //   break;
                  case "flowrate":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Flow Rate: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Flow Rate: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "flowrate":
                  case "flow1_rate":
                  case "flow2_rate":
                  case "flow3_rate":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Flow Rate: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Flow Rate: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "flowtoday":
                  case "flow1_today":
                  case "flow2_today":
                  case "flow3_today":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Flow Today: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Flow Today: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "flowmonth":
                  case "flow1_month":
                  case "flow2_month":
                  case "flow3_month":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Flow Month: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Flow Month: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "flowyear":
                  case "flow1_year":
                  case "flow2_year":
                  case "flow3_year":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Flow Year: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Flow Year: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  case "turbine":
                    tempel.name = element.name;
                    tempel.type = element.type;
                    if (
                      lastdata[el] != null &&
                      lastdata[el] != 0 &&
                      lastdata[el] != undefined
                    )
                      tempel.data =
                        "Turbid: " + parseFloat(lastdata[el]).toFixed(2);
                    else tempel.data = "Turbid: 0";
                    tempel.date = this.$moment(element.date).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                  default:
                    tempel.name = element.name;
                    tempel.type = element.type;
                    tempel.data = el + ": " + lastdata[el];
                    tempel.date = this.$moment(lastdata.t).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    temp.push(tempel);
                    break;
                }
                tempel = {};
              });
              break;
            case "lora":
              // console.log(element.name)
              Object.keys(lastdata).forEach((el) => {
                if (el != "name" && el != "type" && el != "time") {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  if (el == "temp")
                    tempel.data += "Temperature: " + lastdata[el] + " ";
                  else if (el == "humid")
                    tempel.data += "Humidity: " + lastdata[el] + " ";
                  else tempel.data += el + ": " + lastdata[el] + " ";
                  temp.push(tempel);
                  tempel = {};
                }
              });
              break;
            case "yipintsoi":
              console.log(element);
              Object.keys(lastdata).forEach((el) => {
                if (
                  el != "name" &&
                  el != "type" &&
                  el != "timestamp" &&
                  el != "id" &&
                  el != "deviceid"
                ) {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  if (el == "temp")
                    tempel.data += "Temperature: " + lastdata[el] + " ";
                  else if (el == "humid")
                    tempel.data += "Humidity: " + lastdata[el] + " ";
                  else tempel.data += el + ": " + lastdata[el] + " ";
                  temp.push(tempel);
                  tempel = {};
                }
              });
              break;
            case "kubota":
              console.log(element);
              Object.keys(lastdata).forEach((el) => {
                if (
                  el != "name" &&
                  el != "type" &&
                  el != "timestamp" &&
                  el != "id" &&
                  el != "station"
                ) {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  if (el == "temp")
                    tempel.data += "Temperature: " + lastdata[el] + " ";
                  else if (el == "humid")
                    tempel.data += "Humidity: " + lastdata[el] + " ";
                  else tempel.data += el + ": " + lastdata[el] + " ";
                  temp.push(tempel);
                  tempel = {};
                }
              });
              break;
            case "plc":
              console.log(element);
              Object.keys(lastdata).forEach((el) => {
                if (
                  el != "name" &&
                  el != "type" &&
                  el != "timestamp" &&
                  el != "id" &&
                  el != "device"
                ) {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  tempel.data += el + ": " + lastdata[el] + " ";
                  temp.push(tempel);
                  tempel = {};
                }
              });
              break;
            case "mqtt":
            case "lkb":
            case "hino":
            case "qcon":
            case "aqi":
            case "cpf":
            case "ajino":
              // console.log(element.name)
              Object.keys(lastdata).forEach((el) => {
                if (el != "name" && el != "type" && el != "time") {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  if (el == "temp")
                    tempel.data += "Temperature: " + lastdata[el] + " ";
                  else if (el == "humid")
                    tempel.data += "Humidity: " + lastdata[el] + " ";
                  else tempel.data += el + ": " + lastdata[el] + " ";
                  temp.push(tempel);
                  tempel = {};
                }
              });
              break;
            case "frasers":
              // console.log(element.name)
              // Object.keys(lastdata).forEach(el => {
              //   if(el != 'name' && el != 'type' && el != 'time') {
              tempel.name = element.name;
              tempel.type = element.type;
              tempel.active = element.active;
              tempel.network = element.network;
              tempel.date = this.$moment(element.date).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              tempel.temp = "Temperature: " + lastdata.temperature + " ";
              tempel.humid = "Humidity: " + lastdata.humidity + " ";
              tempel.bat = "Humidity: " + lastdata.humidity + " ";
              tempel.signal = "Humidity: " + lastdata.humidity + " ";
              temp.push(tempel);
              tempel = {};
              //   }
              // });
              break;
            case "monnit":
              // console.log(element.name)
              try {
                // console.log(lastdata)
                if (element.name == "BLDG-D-R: Level Water Tank Room - 711356")
                  console.log(lastdata);
                lastdata.forEach((el, i) => {
                  tempel.name = element.name;
                  tempel.type = element.type;
                  tempel.date = this.$moment(element.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  tempel.data = "";
                  tempel.data +=
                    lastdata[i].datatype + ": " + lastdata[i].datavalue + " ";
                  // if(el == 'temperature') tempel.data += 'Temperature: '+lastdata[el]+' '
                  // else if(el == 'humidity') tempel.data += 'Humidity: '+lastdata[el]+' '
                  // else tempel.data += el+': '+lastdata[el]+' '
                  temp.push(tempel);
                  tempel = {};
                });
              } catch (err) {
                if (lastdata != null)
                  Object.keys(lastdata).forEach((el) => {
                    if (el != "name" && el != "type" && el != "time") {
                      tempel.name = element.name;
                      tempel.type = element.type;
                      tempel.date = this.$moment(element.date).format(
                        "YYYY-MM-DD HH:mm:ss"
                      );
                      tempel.data = "";
                      if (el == "datatype" && el != "datavalue") {
                        if (lastdata[el] == "TemperatureData")
                          tempel.data = "Temperature: " + lastdata.datavalue;
                        else
                          tempel.data =
                            lastdata[el] + ": " + lastdata.datavalue;
                        // if(el == 'temperature') tempel.data += 'Temperature: '+lastdata[el]+' '
                        // else if(el == 'humidity') tempel.data += 'Humidity: '+lastdata[el]+' '
                        // else tempel.data += el+': '+lastdata[el]+' '
                        temp.push(tempel);
                        tempel = {};
                      }
                    }
                  });
              }
              break;
          }
          setTimeout(() => {
            this.tempsensor = temp;
            this.lastsensor = temp;
            if (this.username == "frasers.kho") this.changTableFracer();
          }, 100);
          // console.log(temp)
        });
      });
      this.interval = setTimeout(() => {
        this.getSensorData();
      }, 30000);
    },
  },
  created() {
    this.username = this.$session.get("username");
    this.getSensorData();
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>

<style scoped>
.vs-button {
  border-radius: 20px;
}
#noWrap {
  white-space: nowrap;
  font-size: 0.75rem;
}
.span {
  font-size: 14px;
}
.thead {
  padding: 0px;
}
</style>
